import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Hobby3SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      d="m12 5.32-.75-.001v.7l.697.048L12 5.32Zm-8 0 .053.747.698-.049-.001-.7L4 5.32Zm.25 6.24A2.75 2.75 0 0 1 1.5 8.81H0a4.25 4.25 0 0 0 4.25 4.25v-1.5Zm7.5 0h-7.5v1.5h7.5v-1.5Zm2.75-2.75a2.75 2.75 0 0 1-2.75 2.75v1.5A4.25 4.25 0 0 0 16 8.81h-1.5Zm-2.553-2.743A2.75 2.75 0 0 1 14.5 8.811H16a4.25 4.25 0 0 0-3.947-4.24l-.106 1.496Zm-.697-.757v.009l1.5.001v-.009l-1.5-.001ZM8 2.06a3.25 3.25 0 0 1 3.25 3.25l1.5.001A4.75 4.75 0 0 0 8 .561v1.5ZM4.75 5.31A3.25 3.25 0 0 1 8 2.06V.56a4.75 4.75 0 0 0-4.75 4.75h1.5Zm0 .009V5.31h-1.5v.01l1.5-.002ZM1.5 8.81a2.75 2.75 0 0 1 2.553-2.744l-.106-1.496A4.25 4.25 0 0 0 0 8.811h1.5Z"
    />
  </svg>
);
export default Hobby3SVG;
